import ScreenerExpressCheckout from "components/screener/v2/ScreenerExpressCheckout";
import { Badge } from "components/ui/Badge";
import classNames from "components/ui/classNames";
import { LockIcon, XIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";

interface FreeModeBannerProps {
  onClose: () => void;
}
const FreeModeBanner = ({ onClose }: FreeModeBannerProps) => {
  return (
    <div
      className={classNames(
        "flex max-w-md flex-col gap-2 rounded-2xl border border-slate-400/20 bg-slate-500/5 p-4",
        "dark:border-slate-950 dark:bg-rose-600/5",
      )}
    >
      <div className="flex items-center gap-x-2">
        <div>
          <LockIcon
            aria-hidden={true}
            className="size-4 fill-gray-200 stroke-gray-800 dark:fill-transparent dark:stroke-rose-300"
            absoluteStrokeWidth={true}
            strokeWidth={2}
          />
        </div>

        <Badge variant="red" className="inline-flex truncate rounded-md">
          <FormattedMessage defaultMessage="Modo Free" id="yVmeu8" />
        </Badge>
        <button
          type="button"
          className={classNames(
            "ml-auto flex items-center justify-center rounded-full bg-slate-200 p-1",
            "hover:bg-slate-200",
            "focus:outline-none",
            "dark:bg-red-400/10",
            "group size-8",
          )}
          onClick={onClose}
        >
          <XIcon
            absoluteStrokeWidth={true}
            strokeWidth={3}
            className="size-5 stroke-slate-600 group-hover:stroke-slate-500 dark:stroke-rose-400 dark:group-hover:stroke-slate-300"
          />
        </button>
      </div>

      <p className="text-sm font-medium text-slate-600 dark:font-semibold dark:text-rose-200/90">
        <FormattedMessage
          defaultMessage="No Modo Free, vários dados e recursos são limitados. Considere assinar o Fundamentei Premium para usufruir completamente."
          id="TexEae"
        />
      </p>

      <ScreenerExpressCheckout>
        <button
          type="button"
          className={classNames(
            "flex w-full items-center justify-center rounded-lg py-1.5 text-sm font-bold lg:mt-2",
            "border border-navy-300/40 bg-navy-100 text-navy-600",
            "hover:bg-navy-200/80 hover:text-navy-700",
            "dark:border-transparent dark:bg-slate-700 dark:text-slate-300",
            "dark:bg-navy-400/30 dark:text-navy-200",
            "dark:hover:bg-sky-500/30 dark:hover:text-sky-100",
          )}
        >
          <FormattedMessage defaultMessage="Ver preços" id="e+EeZM" />
        </button>
      </ScreenerExpressCheckout>
    </div>
  );
};

export default FreeModeBanner;
